import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import LuxPageHero from '../components/lux/LuxPageHero';
import LuxReveal from '../components/lux/LuxReveal';
import LuxCta from '../components/lux/LuxCta';

const placedStudents = [
  { name: 'Rahul Sharma', course: 'PLC / SCADA', company: 'Siemens', role: 'PLC Engineer', year: '2024' },
  { name: 'Priya Verma', course: 'Data Science', company: 'Infosys', role: 'Data Analyst', year: '2024' },
  { name: 'Amit Kumar', course: 'Industrial Automation', company: 'ABB India', role: 'Automation Engineer', year: '2024' },
  { name: 'Sneha Gupta', course: 'Full Stack Dev', company: 'TCS', role: 'Software Engineer', year: '2024' },
  { name: 'Vikas Singh', course: 'Embedded Systems', company: 'Bosch India', role: 'Embedded Engineer', year: '2023' },
  { name: 'Pooja Yadav', course: 'Digital Marketing', company: 'Wipro', role: 'Digital Marketer', year: '2023' },
  { name: 'Deepak Mishra', course: 'SAP Full Course', company: 'Accenture', role: 'SAP Consultant', year: '2024' },
  { name: 'Ankita Joshi', course: 'Data Science', company: 'HCL Tech', role: 'ML Engineer', year: '2024' },
  { name: 'Rohit Tiwari', course: 'PLC / SCADA', company: 'L&T', role: 'Control Engineer', year: '2023' },
  { name: 'Kavita Sharma', course: 'Full Stack Dev', company: 'Infosys', role: 'Frontend Developer', year: '2023' },
  { name: 'Suresh Patel', course: 'Industrial Automation', company: 'Honeywell', role: 'Automation Technician', year: '2024' },
  { name: 'Meena Rawat', course: 'Data Analyst', company: 'Deloitte', role: 'Business Analyst', year: '2024' },
];

const companyLogos = ['Siemens', 'ABB', 'L&T', 'Bosch', 'Honeywell', 'TCS', 'Infosys', 'Wipro', 'Accenture', 'HCL Tech', 'Deloitte'];

const valuableClients = [
  { name: 'Honeywell', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgXlc_cSs-iur4QGOq2Kf-6DQDYcHgxGJy2w&s' },
  { name: 'ABB', logo: 'https://cdn.worldvectorlogo.com/logos/abb-1.svg' },
  { name: 'Siemens', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1NVQt3HQHP1ax44sxuUX5Sean36ypv7bpHw&s' },
  { name: 'Schneider Electric', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/49/Schneider-Electric-Logo.jpg' },
  { name: 'Rockwell Automation', logo: 'https://rockwellautomation.scene7.com/is/image/rockwellautomation/rockwellautomation-logo-16x9.2550.jpg' },
  { name: 'Mitsubishi', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_bifLsM6iFcAlMgOjJq87zLZy4dMDN1Z7lg&s' },
];

const photos = ['/pl1.jpeg', '/pl3.jpg', '/pl4.jpg', '/pl5.jpg', '/pl6.jpg', '/pl7.jpg', '/pl8.jpg', '/pl10.jpg', '/pl11.jpg', '/pl12.jpg'];

export default function Placements() {
  const [filter, setFilter] = useState('All');
  const courses = ['All', ...Array.from(new Set(placedStudents.map(s => s.course)))];
  const filtered = filter === 'All' ? placedStudents : placedStudents.filter(s => s.course === filter);

  return (
    <>
      <LuxPageHero
        label="Proven Results"
        title="Our Placement"
        highlight="Record"
        description="500+ students placed in top companies. Real jobs, real growth — we deliver on our promise."
      />

      <div className="lux-stats" style={{ borderTop: 'none' }}>
        {[
          { value: '500+', label: 'Students Placed' },
          { value: '95%', label: 'Placement Rate' },
          { value: '200+', label: 'Hiring Partners' },
          { value: '₹4.5L', label: 'Avg. Package' },
        ].map(s => (
          <div key={s.label} className="lux-stats__cell">
            <div className="lux-stats__num" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>{s.value}</div>
            <div className="lux-stats__label">{s.label}</div>
          </div>
        ))}
      </div>

      <section className="lux-photo-marquee">
        <p className="lux-statement__eyebrow" style={{ textAlign: 'center', marginBottom: 24 }}>Life at Bharat Training</p>
        <div className="lux-photo-marquee__track">
          {[...photos, ...photos].map((src, i) => (
            <div key={i} className="lux-photo-marquee__item">
              <img src={src} alt={`Campus ${i}`} loading="lazy" />
            </div>
          ))}
        </div>
      </section>

      <section className="lux-page-section">
        <div className="container-wide">
          <LuxReveal>
            <p className="lux-statement__eyebrow" style={{ textAlign: 'center' }}>Hiring network</p>
            <h2 className="video-gallery__title" style={{ textAlign: 'center', marginBottom: 36 }}>Our students work at</h2>
          </LuxReveal>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center' }}>
            {companyLogos.map((c, i) => (
              <LuxReveal key={c} delay={i * 0.04}>
                <span className="lux-card" style={{ display: 'inline-block', padding: '12px 22px', fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 14 }}>{c}</span>
              </LuxReveal>
            ))}
          </div>
        </div>
      </section>

      <section className="lux-page-section" style={{ background: 'var(--bg-elevated)' }}>
        <div className="container-wide">
          <LuxReveal>
            <h2 className="video-gallery__title" style={{ textAlign: 'center', marginBottom: 48 }}>
              Trusted <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>partners</em>
            </h2>
          </LuxReveal>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, justifyContent: 'center' }}>
            {valuableClients.map((client, i) => (
              <LuxReveal key={client.name} delay={i * 0.06}>
                <motion.div className="lux-card" style={{ width: 150, textAlign: 'center', padding: 20 }} whileHover={{ y: -8 }}>
                  <img src={client.logo} alt={client.name} style={{ maxWidth: 100, maxHeight: 60, objectFit: 'contain', margin: '0 auto 12px' }} />
                  <span style={{ fontSize: 13, fontWeight: 600 }}>{client.name}</span>
                </motion.div>
              </LuxReveal>
            ))}
          </div>
        </div>
      </section>

      <section className="lux-page-section">
        <div className="container-wide">
          <LuxReveal>
            <h2 className="video-gallery__title" style={{ textAlign: 'center', marginBottom: 12 }}>Recent <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>placements</em></h2>
            <p style={{ textAlign: 'center', color: 'var(--text-muted)', marginBottom: 40 }}>Alumni building careers across India.</p>
          </LuxReveal>

          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 40 }}>
            {courses.map(c => (
              <button key={c} type="button" className={`filter-pill ${filter === c ? 'filter-pill--active' : ''}`} onClick={() => setFilter(c)}>{c}</button>
            ))}
          </div>

          <div className="lux-placed-grid">
            {filtered.map((s, i) => (
              <LuxReveal key={s.name + s.company} delay={(i % 6) * 0.05}>
                <motion.div className="lux-placed-card" whileHover={{ y: -6 }}>
                  <div style={{ display: 'flex', gap: 14, marginBottom: 16 }}>
                    <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--grad-btn)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontWeight: 800, color: '#fff' }}>{s.name[0]}</div>
                    <div>
                      <div style={{ fontWeight: 700 }}>{s.name}</div>
                      <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{s.course}</div>
                    </div>
                  </div>
                  <div style={{ padding: 14, background: 'rgba(255,107,44,0.08)', border: '1px solid var(--border)' }}>
                    <div style={{ fontWeight: 800, color: 'var(--accent-soft)' }}>{s.company}</div>
                    <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{s.role}</div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 14, fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                    <span style={{ color: 'var(--text-muted)' }}>Batch {s.year}</span>
                    <span style={{ color: 'var(--accent)' }}>Placed</span>
                  </div>
                </motion.div>
              </LuxReveal>
            ))}
          </div>
        </div>
      </section>

      <LuxCta
        eyebrow="Your turn"
        title="Your name could be"
        highlight="next"
        primary={{ to: '/admission', label: 'Apply Free' }}
        secondary={{ to: '/contact', label: 'Call Us' }}
      />
    </>
  );
}
